module.exports = __webpack_public_path__ + "static/media/location-portable.c9ca5b66.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/location-portable.svg
// module id = 654
// module chunks = 36